import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SharedService {
    // PRICING PANEL
    private pricingPanelData = new BehaviorSubject<any>({
        cadID: '',
        paymentMethod: '',
    });

    private canSubmitSubject = new BehaviorSubject(false);
    canSubmit$ = this.canSubmitSubject.asObservable();
    pricingPanelData$ = this.pricingPanelData.asObservable();

    public submissionDataSubject = new BehaviorSubject(null);

    updatepricingPanelVariable(value) {
        this.pricingPanelData.next(value);
    }

    updateCanSubmitValue(value: boolean) {
        this.canSubmitSubject.next(value);
    }

    //Property List variables
    private propertyListData = new BehaviorSubject<any>({});
    propertyListData$ = this.propertyListData.asObservable();
    updatePropertyListData(value) {
        this.propertyListData.next(value);
    }
    private propertyListSubmitter = new BehaviorSubject<any>({ submit: false });
    propertyListSubmitter$ = this.propertyListSubmitter.asObservable();
    updatePropertyListSubmitter(value) {
        this.propertyListSubmitter.next(value);
    }

    //NOTARY INFO PANEL
    private notaryListData = new BehaviorSubject<any>({});
    notaryListData$ = this.notaryListData.asObservable();
    updateNotaryListData(value) {
        this.notaryListData.next(value);
    }
    private notaryListSubmitter = new BehaviorSubject<any>({ submit: false });
    notaryListSubmitter$ = this.propertyListSubmitter.asObservable();
    updateNotaryListSubmitter(value) {
        this.notaryListSubmitter.next(value);
    }

    //contract INFO PANEL
    private contractListData = new BehaviorSubject<any>({});
    contractListData$ = this.contractListData.asObservable();
    updateContractListData(value) {
        this.contractListData.next(value);
    }
    private contractListSubmitter = new BehaviorSubject<any>({ submit: false });
    contractListSubmitter$ = this.contractListSubmitter.asObservable();
    updateContractListSubmitter(value) {
        this.contractListSubmitter.next(value);
    }

    //document INFO PANEL
    private documentListData = new BehaviorSubject<any>({});
    documentListData$ = this.documentListData.asObservable();
    updateDocumentListData(value) {
        this.documentListData.next(value);
    }
    private documentListSubmitter = new BehaviorSubject<any>({});
    documentListSubmitter$ = this.documentListSubmitter.asObservable();
    updateDocumentListSubmitter(value) {
        this.documentListSubmitter.next(value);
    }
    //attachments INFO PANEL
    private attachmentsListData = new BehaviorSubject<any>({});
    attachmentsListData$ = this.attachmentsListData.asObservable();
    updateAttachmentsListData(value) {
        this.attachmentsListData.next(value);
    }
    private AttachmentsListSubmitter = new BehaviorSubject<any>({
        submit: false,
    });
    AttachmentsListSubmitter$ = this.AttachmentsListSubmitter.asObservable();
    updateAttachmentsListSubmitter(value) {
        this.AttachmentsListSubmitter.next(value);
    }

    //REcalculate Cahrges
    private recalculateCharges = new BehaviorSubject<any>({ cadId: '' });
    recalculateCharges$ = this.recalculateCharges.asObservable();
    recalculateChargesObservable(value) {
        this.recalculateCharges.next(value);
    }

    //NOTARY INFO PANEL
    private involvedPartyListData = new BehaviorSubject<any>({});
    involvedPartyListData$ = this.involvedPartyListData.asObservable();
    updateInvolvedPartyListData(value) {
        this.involvedPartyListData.next(value);
    }
    private involvedPartySubmitter = new BehaviorSubject<any>({});
    involvedPartySubmitter$ = this.involvedPartySubmitter.asObservable();
    updateinvolvedPartySubmitter(value) {
        this.involvedPartySubmitter.next(value);
    }

    makeRandomDocId(lengthOfCode: number) {
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

        let text = '';
        for (let i = 0; i < lengthOfCode; i++) {
            text += possible.charAt(
                Math.floor(Math.random() * possible.length)
            );
        }
        return text;
    }
}
